import styled from 'styled-components';
import { Row, Space, Typography } from 'antd';
import { WarningFilled } from '@ant-design/icons';
import ValueWithDiffError from './ValueWithDiffError';
import { CalculationSummary } from '../types';
import { buildTotalsCalculationsDiff } from '../utils';

const StyledHeader = styled.header`
    border: 1px solid var(--dust-red-4);
    border-radius: 6px;
    padding: 16px 24px;
`;

const Grid = styled.div`
    display: grid;
    align-items: center;
    grid-template-columns: repeat(4, 1fr);
    row-gap: 10px;
    column-gap: 24px;
    margin-top: 8px;
`;

type Props = {
    localCalculations: CalculationSummary;
    revenueCalculations: CalculationSummary;
};

const CalculationsSummaryWithDiscrepancies = ({ localCalculations, revenueCalculations }: Props) => {
    const diffMap = buildTotalsCalculationsDiff(localCalculations, revenueCalculations);

    return (
        <StyledHeader>
            <Row align="middle">
                <Space size={16}>
                    <WarningFilled
                        style={{
                            fontSize: 21,
                            color: 'var(--error-normal)',
                        }}
                    />
                    <Typography.Text
                        style={{
                            fontSize: 16,
                            fontWeight: 600,
                            lineHeight: '24px',
                        }}
                    >
                        There are VAT and duty discrepancies between local calculations and revenue
                    </Typography.Text>
                </Space>
            </Row>

            <Grid>
                <Typography.Text>Local Calculations:</Typography.Text>
                <Typography.Text>
                    Total Customs Duties: <ValueWithDiffError value={localCalculations.totalDuty} />
                </Typography.Text>
                <Typography.Text>
                    Total VAT: <ValueWithDiffError value={localCalculations.totalVat} />
                </Typography.Text>
                <Typography.Text style={{ justifySelf: 'flex-end' }}>
                    Local Total Liability: <ValueWithDiffError value={localCalculations.totalLiability} />
                </Typography.Text>

                <Typography.Text>Revenue: </Typography.Text>
                <Typography.Text>
                    Total Customs Duties:{' '}
                    <ValueWithDiffError value={revenueCalculations.totalDuty} hasError={diffMap.totalDuty} />
                </Typography.Text>
                <Typography.Text>
                    Total VAT: <ValueWithDiffError value={revenueCalculations.totalVat} hasError={diffMap.totalVat} />
                </Typography.Text>
                <Typography.Text style={{ justifySelf: 'flex-end' }}>
                    Revenue Total Liability:{' '}
                    <ValueWithDiffError value={revenueCalculations.totalLiability} hasError={diffMap.totalLiability} />
                </Typography.Text>
            </Grid>
        </StyledHeader>
    );
};

export default CalculationsSummaryWithDiscrepancies;
